import { ALLOWED_STATUSES } from '@/postulation_form/components/attached-files/constants';

export const mustShowAttachedFilesComponent = (filesRequirement) => {
  if (!Array.isArray(filesRequirement)) {
    return false;
  }

  if (filesRequirement.length === 0) {
    return false;
  }

  const visibleRequirements = [ALLOWED_STATUSES.required, ALLOWED_STATUSES.optional];
  return filesRequirement.some((file) => visibleRequirements.includes(file.status));
};

const isValidFileDataStructure = (fileData) => {
  if (!fileData || typeof fileData !== 'object') {
    return false;
  }

  const { uploadedBy } = fileData;

  const requiredFields =
    uploadedBy === 'cv_parser'
      ? ['filename', 'fileType', 'uploadedBy', 'fileIdParsed']
      : ['filename', 'fileType', 'uploadedBy', 'temporalFileName'];

  return requiredFields.every((field) => fileData[field] !== undefined && fileData[field] !== null);
};

export const attachedFilesRequirementsValidation = (attachedFilesRequirements, attachedFiles) => {
  const validationErrors = [];
  if (!Array.isArray(attachedFilesRequirements) || !Array.isArray(attachedFiles)) {
    validationErrors.push({ fileType: null, key: 'invalid_params' });
    return { success: false, errors: validationErrors };
  }

  const requirementsListToCheck = attachedFilesRequirements.filter((fileRequirement) =>
    [ALLOWED_STATUSES.required, ALLOWED_STATUSES.optional].includes(fileRequirement.status)
  );

  for (const fileRequirement of requirementsListToCheck) {
    const attachedFileData = attachedFiles.find(
      (attachedFileStored) => attachedFileStored.fileType === fileRequirement.type
    );

    if (fileRequirement.status === ALLOWED_STATUSES.required) {
      if (!attachedFileData) {
        validationErrors.push({ fileType: fileRequirement.type, key: 'not_found' });
        continue;
      }

      if (!isValidFileDataStructure(attachedFileData)) {
        validationErrors.push({ fileType: fileRequirement.type, key: 'invalid_structure' });
        continue;
      }
    }

    if (fileRequirement.status === ALLOWED_STATUSES.optional) {
      if (attachedFileData && !isValidFileDataStructure(attachedFileData)) {
        validationErrors.push({ fileType: fileRequirement.type, key: 'invalid_structure' });
        continue;
      }
    }
  }

  return validationErrors.length > 0 ? { success: false, errors: validationErrors } : { success: true };
};
